import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import StructureModel from '@Components/Results/structure/structure-model.service';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';
import ReactionViewItemComponent from '@Components/Results/reactions/reaction-view-item.component';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { isNewSynthesisPlannerEnabled } from '@Pages/RetroSynthesis/predictiveUtils';

export default class ReactionViewComponent extends React.Component {
  getList(structures = [], isProducts = false, trailingArrow = false) {
    const { props } = this;
    const containsSubstanceWithNoStructure =
      (!isEmpty(props.reactants) && props.reactants?.filter((reactant) => reactant?.molImage && !reactant?.molImage?.structure)?.length) ||
      (!isEmpty(props.products) && props.products?.filter((product) => product?.molImage && !product?.molImage?.structure)?.length);
    const displayTransferTo =
      props.showToolbar &&
      isProducts &&
      !isEmpty(props.reactants) &&
      !isEmpty(props.products) &&
      props.products?.length === 1 &&
      !containsSubstanceWithNoStructure &&
      isNewSynthesisPlannerEnabled();
    return structures.length
      ? structures.map((structure, i) => (
          <ReactionViewItemComponent
            /* eslint-disable-next-line react/no-array-index-key */
            key={i}
            structure={structure}
            isProduct={isProducts}
            trailingArrow={trailingArrow}
            metadata={props.metadata}
            structureTitle={isProducts && getValueByNs(props, 'products.length') > 1 ? ReactReactionDetailsHelper.getLetterTitle(i) : null}
            zoom={props.zoom}
            isFirst={i === 0}
            isLast={i === structures.length - 1}
            showToolbar={props.showToolbar}
            reactionId={props.reactionId}
            displayTransferTo={displayTransferTo}
          />
        ))
      : null;
  }

  render() {
    const { products, reactants } = this.props;
    return (
      <div className="structure-container">
        {this.getList(reactants, false, isEmpty(products))}
        {this.getList(products, true, false)}
      </div>
    );
  }
}

ReactionViewComponent.propTypes = {
  metadata: PropTypes.object.isRequired,
  reactants: PropTypes.arrayOf(PropTypes.instanceOf(StructureModel)).isRequired,
  products: PropTypes.arrayOf(PropTypes.instanceOf(StructureModel)).isRequired,
  zoom: PropTypes.number,
  showToolbar: PropTypes.bool,
  reactionId: PropTypes.string.isRequired,
};
